import { kuurProducts } from '../core/rules/kuur'
import { policy } from './policies'
import type { Product, Treatment } from '../core/types/catalog'

/** De behandelkamer; een kuur heeft geen eigen productfoto. */
export const KUUR_IMAGE = 'https://cdn.magicpatterns.com/patterns/generated-images/0ed04ad3-0600-47a3-bc34-389527c1fbf3.jpg'

/** Kuren als producten, met de geldigheid uit de instellingen. */
export const kuurProductsFor = (treatments: readonly Treatment[]): Product[] => kuurProducts(treatments, KUUR_IMAGE, policy.kuurValidMonths)
